<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-col
      :span="24"
      class="warp-main"
      v-loading="loading"
      element-loading-text="拼命加载中"
    >
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true" :model="filters" ref="searchForm">
          <el-form-item>
            <el-input
              v-model="filters.name"
              placeholder="平台名称"
              style="min-width: 340px"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="filters.code"
              placeholder="平台编码"
              style="min-width: 340px"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button type="primary" @click="searchReset">重置</el-button>
          <el-button type="primary" @click="showAddDialog">添加平台</el-button>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table :data="platformList" highlight-current-row border lazy>
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="60"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="平台名称"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="code"
          label="平台编码"
          align="center"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="appId"
          label="APPID"
          align="center"
          width="220"
        ></el-table-column>
        <el-table-column
          prop="appSecret"
          label="APPSECRET"
          align="center"
          width="280"
        ></el-table-column>
        <el-table-column
          prop="serverAddress"
          label="接口域名地址"
          align="center"
          width="280"
        ></el-table-column>
        <el-table-column
          prop="createDate"
          label="创建时间"
          align="center"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="createUser"
          label="创建人"
          align="center"
          width="160"
        ></el-table-column>

        <el-table-column label="操作" fixed="right" align="center" width="260">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              style="margin: 0; padding: 5px"
              @click="showEditDialog(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="primary"
              style="margin: 0; padding: 5px"
              @click="showInter(scope.$index, scope.row)"
              >接口</el-button
            >
            <!-- <el-button
              size="mini"
              type="primary"
              style="margin: 0; padding: 5px"
              @click="showProject(scope.$index, scope.row)"
              >项目</el-button
            > -->
            <el-button
              size="mini"
              type="primary"
              style="margin: 0; padding: 5px"
              @click="showDict(scope.$index, scope.row)"
              >类型字典</el-button
            >
            <el-button
              size="mini"
              type="danger"
              style="margin: 0; padding: 5px"
              @click="remove(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>

      <!-- 添加、修改界面 -->
      <el-dialog
        :title="form.title"
        :visible.sync="form.visible"
        :close-on-click-modal="false"
      >
        <el-form
          :model="form.data"
          label-width="80px"
          :rules="form.rules"
          ref="formref"
        >
          <table style="width: 100%">
            <tr>
              <td>
                <el-form-item
                  label="平台名称"
                  label-width="120px"
                  prop="name"
                  class="clear-margin-bottom"
                >
                  <el-input
                    v-model="form.data.name"
                    placeholder="平台名称"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="平台编码" label-width="120px" prop="code">
                  <el-input
                    v-model="form.data.code"
                    placeholder="平台编码"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="APPID" label-width="120px" prop="appId">
                  <el-input
                    v-model="form.data.appId"
                    placeholder="APPID"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item
                  label="APPSECRET"
                  label-width="120px"
                  prop="appSecret"
                >
                  <el-input
                    v-model="form.data.appSecret"
                    placeholder="APPSECRET"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item
                  label="接口域名地址"
                  label-width="120px"
                  prop="serverAddress"
                >
                  <el-input
                    v-model="form.data.serverAddress"
                    placeholder="接口域名地址"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item
                  label="是否自动上报"
                  label-width="120px"
                  prop="reportFlag"
                >
                  <el-switch
                    v-model="form.data.reportFlag"
                    active-color="#13ce66"
                    inactive-color="#DCDFE6"
                  >
                  </el-switch>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="备注" label-width="120px">
                  <el-input
                    type="textarea"
                    :row="4"
                    v-model="form.data.remark"
                    placeholder="备注"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
          </table>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="form.visible = false">取消</el-button>
          <el-button
            type="primary"
            @click.native="form.submit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-dialog>
      <!-- 接口维护 -->
      <el-dialog
        :title="inter.title"
        :visible.sync="inter.visible"
        width="95%"
        top="5vh"
        :close-on-click-modal="false"
      >
        <Inter :platformId="inter.platformId" :openflg="inter.openflg"></Inter>
      </el-dialog>
      <!-- 项目维护 -->
      <!-- <el-dialog
        :title="project.title"
        :visible.sync="project.visible"
        width="95%"
        top="5vh"
        :close-on-click-modal="false"
      >
        <Pject
          :platformId="project.platformId"
          :openflg="project.openflg"
        ></Pject>
      </el-dialog> -->
      <!-- 设备类型维护 -->
      <el-dialog
        :title="dict.title"
        :visible.sync="dict.visible"
        width="95%"
        top="5vh"
        :close-on-click-modal="false"
      >
        <Dict :platformId="dict.platformId" :openflg="dict.openflg"></Dict>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
import API from "../../api/third/platform";
import TreeSelect from "@/components/selectTree/treeSelect.vue";
import Inter from "@/components/third/inter.vue";
import Dict from "@/components/third/dict.vue";
import Pject from "@/components/third/project.vue";
export default {
  components: { TreeSelect, Inter, Dict, Pject },
  data() {
    return {
      loading: false,
      platformList: [],
      total: 0,
      page: 1,
      limit: 10,
      //条件
      filters: {
        name: undefined,
        code: undefined
      },
      //编辑窗体
      form: {
        loading: false, //加载动画
        title: "", //编辑窗体名称
        visible: false, //窗体是否显示
        rules: {
          //验证逻辑
          name: [
            {
              required: true,
              message: "请输入平台名称",
              trigger: ["blur", "change"]
            },
            {
              min: 1,
              max: 100,
              message: "长度1-100个字符",
              trigger: ["blur", "change"]
            }
          ],
          code: [
            {
              required: true,
              message: "请输入平台编码",
              trigger: ["blur", "change"]
            }
          ],
          appId: [
            {
              required: true,
              message: "请输入APPID",
              trigger: ["blur", "change"]
            }
          ],
          appSecret: [
            {
              required: true,
              message: "请输入APPSECRET",
              trigger: ["blur", "change"]
            }
          ],
          projectOpenId: [
            {
              required: true,
              message: "请输入二级项目ID",
              trigger: ["blur", "change"]
            }
          ]
        },
        data: {},
        //定义form的提交按钮
        submit: function () {}
      },
      inter: {
        title: "接口管理",
        visible: false
      },
      project: {
        title: "关联项目",
        visible: false
      },
      dict: {
        title: "设备类型管理",
        visible: false
      }
    };
  },
  watch: {},
  methods: {
    //文本框不能输入中文
    check_zh() {
      let that = this;
      that.addForm.userName = that.addForm.userName.replace(
        /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g,
        ""
      );
    },
    //重置
    searchReset: function () {
      this.filters = {};
      this.$refs.searchForm.resetFields();
    },
    //获取平台数据
    search: function () {
      let that = this;
      let params = {
        page: that.page,
        limit: that.limit,
        name: that.filters.name ? that.filters.name : undefined,
        code: that.filters.code ? that.filters.code : undefined
      };

      that.loading = true;
      API.getList(params)
        .then(
          function (result) {
            that.loading = false;
            if (result && result.code == 200) {
              that.total = result.data.total;
              that.platformList = result.data.records;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    handleSizeChange(val) {
      this.limit = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    handleSearch() {
      this.total = 0;
      this.page = 1;
      this.search();
    },
    //添加
    showAddDialog() {
      let that = this;
      that.form.title = "新增平台信息";
      that.form.data = {};
      that.form.visible = true;
      if (that.$refs.formref) {
        that.$refs.formref.resetFields();
      }
      //提交保存
      that.form.submit = function () {
        that.$refs.formref.validate((valid) => {
          if (valid) {
            API.insert(that.form.data)
              .then(
                function (result) {
                  that.loading = false;
                  if (result && result.code == 200) {
                    that.$message.success({
                      showClose: true,
                      message: "新增成功",
                      duration: 2000
                    });
                    that.form.visible = false;
                    that.search();
                  } else {
                    that.$message.error({
                      showClose: true,
                      message: result.msg,
                      duration: 2000
                    });
                  }
                },
                function (err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function (error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          }
        });
      };
    },
    //编辑
    showEditDialog(index, row) {
      let that = this;
      that.form.title = "编辑平台信息";
      that.form.data = {};
      that.form.visible = true;
      if (that.$refs.formref) {
        that.$refs.formref.resetFields();
      }
      //加载详情数据
      that.form.visible = true;
      that.loading = true;
      API.detail(row.platformId)
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.loading = false;
              console.log(result.data);
              //赋值
              that.form.data = result.data;
            } else {
              that.$message.error({
                showClose: true,
                message: result.msg,
                duration: 2000
              });
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });

      //提交
      that.form.submit = function () {
        that.$refs.formref.validate((valid) => {
          if (valid) {
            API.update(that.form.data)
              .then(
                function (result) {
                  that.loading = false;
                  if (result && result.code == 200) {
                    that.$message.success({
                      showClose: true,
                      message: "修改成功",
                      duration: 2000
                    });
                    that.form.visible = false;
                    that.search();
                  } else {
                    that.$message.error({
                      showClose: true,
                      message: result.msg,
                      duration: 2000
                    });
                  }
                },
                function (err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function (error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          }
        });
      };
    },
    //删除
    remove(index, row) {
      let that = this;
      this.$confirm("确认删除该记录吗?", "提示", { type: "warning" })
        .then(() => {
          that.loading = true;
          API.delete(row.platformId)
            .then(
              function (result) {
                that.loading = false;
                if (result && result.code === 200) {
                  that.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 1500
                  });
                  that.search();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.msg,
                    duration: 1500
                  });
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    },
    showInter(index, row) {
      this.inter.visible = true;
      this.inter.platformId = row.platformId;
      this.inter.openflg =
        this.inter.openflg == undefined ? 0 : this.inter.openflg + 1;
    },
    showProject(index, row) {
      this.project.visible = true;
      this.project.platformId = row.platformId;
      this.project.openflg =
        this.inter.openflg == undefined ? 0 : this.inter.openflg + 1;
    },
    showDict(index, row) {
      this.dict.visible = true;
      this.dict.platformId = row.platformId;
      this.dict.openflg =
        this.dict.openflg == undefined ? 0 : this.dict.openflg + 1;
    }
  },
  mounted() {
    this.handleSearch();
  }
};
</script>



// WEBPACK FOOTER //
// platform.vue?2e839c1c